import * as bus from "@sinch/bus";
import { ENTRY } from "./helpers/getEnv";

// Don't use this outside of this file
const windowPf = window as unknown as {
  meta: {
    platform?: bus.PLATFORM_PAYLOAD;
  };
};

windowPf.meta = {
  ...windowPf.meta,
  platform: ENTRY as bus.PLATFORM_PAYLOAD,
};
// Respond with most current token on Token Requests™.
// This will have issues with multiple tabs and windows for the same page but will due for now.
const unsub = bus.listen(() => {
  bus.sendLocal(bus.platformMessage(ENTRY as bus.PLATFORM_PAYLOAD));
}, bus.isPlatformRequestMessage);

window.addEventListener("unload", unsub);
